import { gsap } from 'gsap'
import axios from 'axios'
const qs = require('qs')
const prod = process.env.NODE_ENV === 'production'
const lib = require('../library')

export default class CartQtyProduct {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.continue = document.querySelector('[data-continue-estimate]')
    this.cartItem = this.el.closest('[data-cart-item]')
    this.button = this.el.querySelector('.js-qty-item')
    this.qtyInput = this.el.querySelector('[data-qty-input]')
    this.qtyInput.classList.add('testing')
    if (this.qtyInput) {
      this.purchaseableId = this.qtyInput.dataset.lineitemid
      this.miniCart = document.querySelector('[data-mini-cart-count]')
    }
  }

  init() {
    if (lib.isDev) {
    }
    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', this.handleCartQty)
    }
  }

  updateCart(count) {
    if (count === 0) {
      location.reload()
    } else if (this.miniCart) {
      this.miniCart.innerHTML = count
    }
  }

  handleUpdateElem() {
    // this.button.classList.add("s-cart-removing");
    // this.el.classList.add("opacity-50");
  }

  handleSuccessButton() {
    // this.button.classList.remove("s-cart-removing");
    // this.button.classList.add("s-cart-success");
  }

  disableContinue() {
    this.continue.classList.add('opacity-25')
  }

  enableContinue() {
    this.continue.classList.remove('opacity-25')
  }

  handleCartQty = (e) => {
    e.preventDefault()
    this.disableContinue()
    const { value } = this.qtyInput
    const data = {
      action: 'commerce/cart/update-cart',
      lineItems: { [this.purchaseableId]: { qty: value } },
    }

    const options = {
      method: 'post',
      url: '/',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': window.CSRFToken,
      },
      data: qs.stringify(data),
    }
    axios(options)
      .then((response) => {
        this.updateCart(response.data.cart.totalQty)
        this.handleSuccessButton()
        this.handleUpdateElem()
        this.enableContinue()
        e.preventDefault()
        if (value == 0) {
          this.cartItem.remove()
        }
      })
      .catch((error) => {
        lib.logError(error)
      })
  }
}
